import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Namespace } from '@wix/ambassador-site-list-v2-site/types';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
// Namespaces that represent real user-owned sites. Mirrors the filter used by
// the Wix Owner App's sites-list module (mobile-apps-sites-list) — excludes
// drafts, albums, logos, dev sites, etc.
const USER_SITE_NAMESPACES = [Namespace.ANYWHERE, Namespace.DASHBOARD_FIRST, Namespace.WIX, Namespace.HEADLESS, Namespace.BRANDED_FIRST, Namespace.CREATOR_ECONOMY];
export class SiteListClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "querySitesImpl", void 0);
    _defineProperty(this, "countSitesImpl", void 0);
  }
  async queryUserSites(cursor) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        sites,
        metadata
      } = await this.request(this.querySitesImpl({
        query: {
          filter: {
            namespace: {
              $in: USER_SITE_NAMESPACES
            }
          },
          cursorPaging: cursor ? {
            cursor,
            limit: 50
          } : {
            limit: 50
          }
        }
      }), ...args);
      return {
        items: sites ?? [],
        ...pagingMetadataToCursorResponse(metadata)
      };
    } catch (error) {
      this.logError('queryUserSites', 'Failed to query user sites', {
        cursor
      }, error);
      throw error;
    }
  }
  async countUserSites() {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      const {
        count
      } = await this.request(this.countSitesImpl({
        filter: {
          namespace: {
            $in: USER_SITE_NAMESPACES
          }
        }
      }), ...args);
      return count ?? 0;
    } catch (error) {
      this.logError('countUserSites', 'Failed to count user sites', {}, error);
      throw error;
    }
  }
  convertToEntity(site) {
    if (!site) {
      throw new Error('Site is required');
    }
    return site;
  }
  getServiceNameForLogs() {
    return 'SiteListClient';
  }
}
//# sourceMappingURL=SiteListClientBase.js.map